import { render, staticRenderFns } from "./people_admin_tab.vue?vue&type=template&id=3324b70f&"
import script from "./people_admin_tab.vue?vue&type=script&lang=js&"
export * from "./people_admin_tab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/planorama/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3324b70f')) {
      api.createRecord('3324b70f', component.options)
    } else {
      api.reload('3324b70f', component.options)
    }
    module.hot.accept("./people_admin_tab.vue?vue&type=template&id=3324b70f&", function () {
      api.rerender('3324b70f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/people/people_admin_tab.vue"
export default component.exports